import { HTMLProps, Ref } from 'react';

interface Props extends HTMLProps<HTMLSelectElement> {
  error?: boolean;
  innerRef?: Ref<HTMLSelectElement>;
  options?: { text: string; value: string }[];
}

export default function Select({
  error = false,
  className = '',
  options,
  innerRef,
  ...others
}: Props) {
  return (
    <select
      className={`p-1 h-10 w-full border-2 rounded-md bg-slate-50 focus:border-primary-600 outline-none
      ${error ? 'border-red-400' : 'border-primary-400'} ${className}`}
      ref={innerRef}
      {...others}
    >
      {options?.map((o) => (
        <option value={o.value}>{o.text}</option>
      ))}
    </select>
  );
}
